import React from 'react';
interface ProgressBarProps {
  label: string;
  value: string | React.ReactNode;
  percentage: number;
  colorClass: string;
  bgClass?: string;
  showCheckmarks?: boolean;
  flipped?: boolean;
}
export function ProgressBar({
  label,
  value,
  percentage,
  colorClass,
  bgClass = 'bg-gray-100',
  showCheckmarks,
  flipped = false
}: ProgressBarProps) {
  return <div className="w-full" data-id="element-23">
      <div className="flex justify-between items-end mb-2" data-id="element-24">
        <span className="text-sm font-semibold text-gray-900" data-id="element-25">{label}</span>
        <div className="flex items-center gap-2" data-id="element-26">
          {showCheckmarks && <div className="flex gap-0.5" data-id="element-27">
              <div className="w-3.5 h-3.5 rounded-full bg-gray-800 flex items-center justify-center text-white text-[8px]" data-id="element-28">
                ✓
              </div>
              <div className="w-3.5 h-3.5 rounded-full bg-gray-800 flex items-center justify-center text-white text-[8px]" data-id="element-29">
                ✓
              </div>
              <div className="w-3.5 h-3.5 rounded-full bg-gray-800 flex items-center justify-center text-white text-[8px]" data-id="element-30">
                ✓
              </div>
            </div>}
          <span className="text-xs font-medium text-gray-500" data-id="element-31">{value}</span>
        </div>
      </div>
      <div className={`h-2 w-full rounded-full overflow-hidden flex ${flipped ? 'justify-end' : 'justify-start'} ${bgClass}`} data-id="element-32">
        <div className={`h-full rounded-full transition-all duration-500 ${colorClass}`} style={{
        width: `${percentage}%`
      }} data-id="element-33" />
      </div>
    </div>;
}